import { SimpleDocCommand } from '../DocsApp/commands/v5/types';
import { CommandExecutionContext } from '../../types/commands';
import { StandardToolResult } from '../../types/standardToolResults';
import fetchService from '../../services/fetchService';
import { API_BASE_URL } from '../../api/config';
import { MANIFEST } from './slack_list_dms.m';
import { schemaToParameters } from '../../utils/schemaToParameters';

const log = { log: (...a: any[]) => console.log('[SLACK_QUERY_TOOL]', ...a) };

export const slack_list_dms: SimpleDocCommand = {
  id: MANIFEST.name,
  logicalName: 'slack_list_dms',
  version: 'v1',
  description: MANIFEST.description,

  schema: {
    parameters: schemaToParameters(MANIFEST.inputSchema),
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { workspaceId, limit = 20 } = params;

    try {
      const urlParams = new URLSearchParams();
      if (workspaceId) urlParams.set('workspace_id', workspaceId);
      urlParams.set('limit', String(Math.min(100, Math.max(1, limit))));

      const data = await fetchService(
        `${API_BASE_URL}/integrations/slack/list-dms?${urlParams}`,
        { method: 'GET' }
      );

      if (data.error || data.detail) {
        const detail = data.detail || data.error;
        return {
          status: 'error',
          message: detail.includes('not connected')
            ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
            : `Slack list-dms failed: ${detail}`,
          error: { code: 'list_dms_failed', category: 'execution', details: detail },
          format: 'plaintext',
        };
      }

      const conversations = Array.isArray(data) ? data : [];
      log.log(`list-dms: found ${conversations.length} conversations`);
      return {
        status: 'success',
        message: `Found ${conversations.length} DM conversation${conversations.length !== 1 ? 's' : ''}`,
        data: { conversations, count: conversations.length },
        format: 'json',
      };
    } catch (error: any) {
      const detail = error.data?.detail || error.message || 'Unknown error';
      return {
        status: 'error',
        message: detail.includes('not connected')
          ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
          : `Slack list-dms failed: ${detail}`,
        error: { code: 'error', category: error.status === 400 ? 'validation' : 'execution', details: detail },
        format: 'plaintext',
      };
    }
  },
};
